import { Validators } from "@angular/forms";

// Constants
export const SWISSCOM_HEALTH_ORG_ADMIN_WRITE: string =
  "swisscom-allCma-health-orgadministration-write";

// Validators
export const VALIDATOR_COUNTRY_CODE = Validators.pattern(/^[A-Z]{2}$/);
export const VALIDATOR_GTIN_13_LIST = Validators.pattern(/^(?:\d{13},?)*$/);
export const VALIDATOR_NAME = Validators.pattern(/^[a-zA-Z0-9 \.\-\(\)\u00C0-\u00FC]{1,80}(?<! )$/);
